import {h, Component} from 'preact';
import { CheckboxWithLabel } from '@webapp/preact-shared';

export default class OnPasswordUpdated extends Component {
    constructor() {
        super();
        this.state = {
            showPassword: false
        }
    }

    toggleShowPassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    };

    render({getPassword}, {showPassword}) {
        return(
            <div className='on-password-updated'>
                <h4 className='success-message d-flex align-items-center'>
                    <i className="wi wi-check" /><span>Your password has been updated successfully.</span>
                </h4>
                <h4>To prevent getting locked out of Workplace, please update your new password on other devices or connected apps that you may have.</h4>
                <div className='instruction-step d-flex align-items-center'>
                    <h2>1</h2>
                    <h5>Sign in with your work email and newly minted password. Need a hint?</h5>
                    <div className='password-field-wrapper d-flex align-items-center'>
                        <input type={showPassword ? 'text' : 'password'}
                               className='form-control'
                               value={getPassword()}
                               readOnly
                        />
                        <CheckboxWithLabel label='Show password' checked={showPassword} action={this.toggleShowPassword}/>
                    </div>
                </div>
                <div className='instruction-step d-flex align-items-center'>
                    <h2>2</h2>
                    <h5>Please use the password you just created on other devices, and connected apps.</h5>
                </div>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/scripts/views/tags/on-password-updated.js